/**
 * group-member.js
 */

import React from 'react';
import { ListItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { UserContext } from 'contexts/user/user-context';
import Icon from 'components/icon';
import GroupMemberAvatar from './group-member-avatar';


const useStyles = makeStyles(theme => ({
  listItem: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: 0,
    paddingRight: 0,
    color: props => props.highlight ? theme.palette.primary.main : undefined,
    '& .MuiListItemIcon-root': {
      minWidth: 'auto',
      marginRight: theme.spacing(1),
    },
    '& .MuiListItemAvatar-root': {
      marginRight: theme.spacing(2),
      '& .MuiAvatar-root': {          
        backgroundColor: props => props.highlight ? theme.palette.primary.main : undefined,
      }
    },
    '& .primary-content': {
      flex: 1,
      overflow: 'hidden',
      flexDirection: 'column',
      alignItems: 'flex-start',
      '& .MuiListItemText-root': {
        width: '100%',
        flex: 'unset',
        marginTop: 0,
        marginBottom: 0,
        marginRight: theme.spacing(1),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '& > *': {
          overflow: 'inherit',
          textOverflow: 'inherit',
        },
        '& .MuiListItemText-primary': {
          fontWeight: props => props.highlight ? 'bold' : 'normal',
          whiteSpace: 'nowrap',
          '& .MuiSvgIcon-root': {
            color: theme.palette.warning.main,
            marginLeft: 5,
            position: 'relative',
            top: -1,
          }
        },
        '& .MuiListItemText-secondary': {
          fontSize: theme.typography.sizes[1],
        }
      },
      '& .MuiChip-root': {
        marginTop: 2
      },
      [theme.breakpoints.down('sm')]: {
        '& .MuiListItemText-root': {
          marginBottom: 2,
          '&:last-child': {
            marginBottom: 0
          }
        }
      }
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: 2
    }
  }
}));


export default function GroupMember(props) {
  const { 
    component, 
    icon, 
    member, 
    memberExtra, 
    actions,
    initials, 
    highlight,
  } = props;
  const classes = useStyles({ highlight });
  const { user } = React.useContext(UserContext);


  return (
    <ListItem dense className={classes.listItem} component={component}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      
      <GroupMemberAvatar name={member?.name} initials={initials} />

      <div className={`flex-hc primary-content`}>
        <ListItemText 
          primary={<>
            {member.id === user.id ? 'Me' : member.name}

            {/* hack in the no dogs warning */}
            {member?.activeDogCount === 0 &&
            <Tooltip arrow placement='top' title='No Active Dogs'>
              <span className='flex-hc'><Icon type='warning' fontSize='small' /></span>
            </Tooltip>}

          </>} 
          secondary={member.email?.toLowerCase()}
        />
        {memberExtra}        
      </div>

      {actions}
    </ListItem>
  );
}